var map = {
	"./BG1.jpg": 25294,
	"./BG10.jpg": 58644,
	"./BG11.jpg": 72977,
	"./BG12.jpg": 45222,
	"./BG13.jpg": 88355,
	"./BG14.jpg": 12080,
	"./BG15.jpg": 64301,
	"./BG16.jpg": 18370,
	"./BG17.jpg": 10079,
	"./BG18.jpg": 51708,
	"./BG19.jpg": 72761,
	"./BG2.jpg": 5561,
	"./BG20.jpg": 91461,
	"./BG21.jpg": 63848,
	"./BG22.jpg": 74775,
	"./BG23.jpg": 3610,
	"./BG3.jpg": 18684,
	"./BG4.jpg": 36583,
	"./BG5.jpg": 68842,
	"./BG6.jpg": 60917,
	"./BG7.jpg": 40248,
	"./BG8.jpg": 97859,
	"./BG9.jpg": 24102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28842;